import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import BottomNav from "../../components/BottomNav";
import api from "../../services/api";
import styles from "./cadastro.module.css";
import ApiButton from "../../components/ApiButton/ApiButton";

// "08/09/1982 00:00:00" → "08/09/1982"
// "1982-09-08 00:00:00.000" → "08/09/1982"
const toDateBR = (val) => {
    if (!val) return "";
    const s = String(val).trim();
    // já vem DD/MM/YYYY (com ou sem hora)
    const slashes = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (slashes) return `${slashes[1]}/${slashes[2]}/${slashes[3]}`;
    // vem YYYY-MM-DD (com ou sem hora)
    const dashes = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dashes) return `${dashes[3]}/${dashes[2]}/${dashes[1]}`;
    return "";
};

// "08/09/1982" → "1982-09-08"
const toDateISO = (val) => {
    if (!val) return "";
    const match = String(val).trim().match(/(\d{2})\/(\d{2})\/(\d{4})/);
    return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
};

// máscara automática: insere barras conforme digita
const maskDate = (val) => {
    const d = val.replace(/\D/g, "").substring(0, 8);
    if (d.length <= 2) return d;
    if (d.length <= 4) return `${d.slice(0,2)}/${d.slice(2)}`;
    return `${d.slice(0,2)}/${d.slice(2,4)}/${d.slice(4)}`;
};

const filhoVazio = () => ({ nomfil: "", datani: "" });
const cursoVazio = () => ({ nomcur: "", nomins: "", datini: "", datfin: "", qtdcar: "", arquivo: null, arquivoNome: "" });
const emergVazio = () => ({ nomeme: "", parer: "", teleme: "" });

const ESCOLARIDADES = [
    "Fundamental Incompleto",
    "Fundamental Completo",
    "Médio Incompleto",
    "Médio Completo",
    "Técnico",
    "Superior Incompleto",
    "Superior Completo",
    "Pós-Graduação / MBA",
    "Mestrado",
    "Doutorado",
];

export default function Cadastro() {
    const { user } = useContext(AuthContext);
    const [loading, setLoading]   = useState(true);
    const [salvando, setSalvando] = useState(false);

    const [form, setForm] = useState({
        emails: "",
        fonfun: "",
        datnas: "",
        grains: "",
        endfun: "",
        numend: "",
        baifun: "",
        cidfun: "",
        estfun: "",
        numcep: "",
    });

    const [filhos,    setFilhos]    = useState([]);
    const [cursos,    setCursos]    = useState([]);
    const [emergencia, setEmergencia] = useState(emergVazio());

    useEffect(() => {
        async function carregar() {
            try {
                const params = `tipfun=${user.tipfun}&codfun=${user.codfun}`;

                const [resDados, resFilhos, resCursos] = await Promise.all([
                    api.get(`/colaborador/dados/?${params}`),
                    //api.get(`/colaborador/filhos/?${params}`),
                    api.get(`/colaborador/cursos/?${params}`),
                ]);

                const d = resDados.data;
                setForm({
                    emails: d.emails ?? "",
                    fonfun: d.fonfun ?? "",
                    datnas: toDateBR(d.datnas),
                    grains: d.grains ?? "",
                    endfun: d.endfun ?? "",
                    numend: d.numend ?? "",
                    baifun: d.baifun ?? "",
                    cidfun: d.cidfun ?? "",
                    estfun: d.estfun ?? "",
                    numcep: d.numcep ?? "",
                });
                setEmergencia(
                    d.emergencia ? { ...emergVazio(), ...d.emergencia } : emergVazio()
                );

                // const filhosData = Array.isArray(resFilhos.data) ? resFilhos.data : [];
                // setFilhos(
                //     filhosData.map(f => ({ ...f, datani: toDateBR(f.datani) }))
                // );

                const cursosData = Array.isArray(resCursos.data) ? resCursos.data : [];
                setCursos(
                    cursosData.map(c => ({ ...cursoVazio(), ...c, datini: toDateBR(c.datini), datfin: toDateBR(c.datfin) }))
                );
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        carregar();
    }, []);

    function handleForm(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    async function buscarCep(cep) {
        const soNumeros = cep.replace(/\D/g, "");
        if (soNumeros.length !== 8) return;
        try {
            const res = await fetch(`https://viacep.com.br/ws/${soNumeros}/json/`);
            const data = await res.json();
            if (data.erro) return;
            setForm(prev => ({
                ...prev,
                endfun: data.logradouro ?? prev.endfun,
                baifun: data.bairro     ?? prev.baifun,
                cidfun: data.localidade ?? prev.cidfun,
                estfun: data.uf         ?? prev.estfun,
            }));
        } catch (err) {
            console.error("Erro ao buscar CEP:", err);
        }
    }

    function handleFilho(i, campo, valor) {
        setFilhos(prev => prev.map((f, idx) => idx === i ? { ...f, [campo]: valor } : f));
    }

    function handleCurso(i, campo, valor) {
        setCursos(prev => prev.map((c, idx) => idx === i ? { ...c, [campo]: valor } : c));
    }

    function handleCursoArquivo(i, file) {
        if (!file) return;
        setCursos(prev => prev.map((c, idx) =>
            idx === i ? { ...c, arquivo: file, arquivoNome: file.name } : c
        ));
    }

    function handleEmerg(campo, valor) {
        setEmergencia(prev => ({ ...prev, [campo]: valor }));
    }

    async function salvar() {
        try {
            setSalvando(true);

            const formData = new FormData();

            formData.append("dados", JSON.stringify({
                // fpd122
                codfun: user.codfun,
                emails: form.emails,
                fonfun: form.fonfun,
                datnas: toDateISO(form.datnas),
                grains: form.grains,
                endfun: form.endfun,
                numend: form.numend,
                baifun: form.baifun,
                cidfun: form.cidfun,
                estfun: form.estfun,
                numcep: form.numcep,
                // fpd122 - emergência
                nomeme: emergencia.nomeme,
                parer:  emergencia.parer,
                teleme: emergencia.teleme,
                // fpd123 - filhos
                filhos: filhos.map(f => ({
                    nomfil: f.nomfil,
                    datani: toDateISO(f.datani),
                })),
                // fpd125 - cursos (sem arquivo)
                cursos: cursos.map(({ arquivo, arquivoNome, ...rest }) => ({
                    ...rest,
                    datini: toDateISO(rest.datini),
                    datfin: toDateISO(rest.datfin),
                })),
            }));

            // anexa certificados individualmente: certificado_0, certificado_1 ...
            cursos.forEach((c, i) => {
                if (c.arquivo) formData.append(`certificado_${i}`, c.arquivo);
            });

            await api.post(
                `/colaborador/dadoscadastrais/?codfun=${user.codfun}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            alert("Dados salvos com sucesso!");
        } catch (err) {
            console.error(err);
            alert("Erro ao salvar dados.");
        } finally {
            setSalvando(false);
        }
    }

    if (loading) {
        return (
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.headerIcon}>👤</div>
                    <div className={styles.headerTexto}>
                        <h2>Meu Cadastro</h2>
                        <p>Carregando seus dados...</p>
                    </div>
                </div>
                <BottomNav />
            </div>
        );
    }

    return (
        <div className={styles.container}>

            <div className={styles.header}>
                <div className={styles.headerIcon}>👤</div>
                <div className={styles.headerTexto}>
                    <h2>Meu Cadastro</h2>
                    <p>Mantenha seus dados sempre atualizados</p>
                </div>
            </div>

            {/* CONTATO */}
            <div className={styles.secao}>
                <span className={styles.secaoTitulo}>📞 Contato</span>

                <div className={styles.campo}>
                    <label className={styles.label}>E-mail</label>
                    <input className={styles.input} type="email" placeholder="seu@email.com"
                        value={form.emails} onChange={e => handleForm("emails", e.target.value)} />
                </div>

                <div className={styles.campo}>
                    <label className={styles.label}>Telefone / WhatsApp</label>
                    <input className={styles.input} type="tel" placeholder="(00) 00000-0000"
                        value={form.fonfun} onChange={e => handleForm("celfun", e.target.value)} />
                </div>
            </div>

            {/* ENDEREÇO */}
            <div className={styles.secao}>
                <span className={styles.secaoTitulo}>📍 Endereço</span>

                <div className={styles.gridDois}>
                    <div className={styles.campo}>
                        <label className={styles.label}>CEP</label>
                        <input className={styles.input} type="text" placeholder="00000-000"
                            value={form.numcep}
                            onChange={e => {
                                handleForm("numcep", e.target.value);
                                buscarCep(e.target.value);
                            }} />
                    </div>
                    <div className={styles.campo}>
                        <label className={styles.label}>UF</label>
                        <input className={styles.input} type="text" placeholder="SP" maxLength={2}
                            value={form.estfun}
                            onChange={e => handleForm("estfun", e.target.value.toUpperCase())} />
                    </div>
                </div>

                <div className={styles.campo}>
                    <label className={styles.label}>Logradouro</label>
                    <input className={styles.input} type="text" placeholder="Rua, Avenida..."
                        value={form.endfun} onChange={e => handleForm("endfun", e.target.value)} />
                </div>

                <div className={styles.gridDois}>
                    <div className={styles.campo}>
                        <label className={styles.label}>Número</label>
                        <input className={styles.input} type="text" placeholder="Nº"
                            value={form.numend} onChange={e => handleForm("numend", e.target.value)} />
                    </div>
                    <div className={styles.campo}>
                        <label className={styles.label}>Bairro</label>
                        <input className={styles.input} type="text" placeholder="Bairro"
                            value={form.baifun} onChange={e => handleForm("baifun", e.target.value)} />
                    </div>
                </div>

                <div className={styles.campo}>
                    <label className={styles.label}>Cidade</label>
                    <input className={styles.input} type="text" placeholder="Cidade"
                        value={form.cidfun} onChange={e => handleForm("cidfun", e.target.value)} />
                </div>
            </div>

            {/* DADOS PESSOAIS */}
            <div className={styles.secao}>
                <span className={styles.secaoTitulo}>👤 Dados Pessoais</span>

                <div className={styles.campo}>
                    <label className={styles.label}>Data de Nascimento</label>
                    <input className={styles.input} type="text" placeholder="dd/mm/aaaa" maxLength={10}
                        value={form.datnas}
                        onChange={e => handleForm("datnas", maskDate(e.target.value))} />
                </div>

                <div className={styles.campo}>
                    <label className={styles.label}>Escolaridade</label>
                    <select className={styles.input} value={form.grains}
                        onChange={e => handleForm("grains", e.target.value)}>
                        <option value="">Selecione...</option>
                        {ESCOLARIDADES.map(e => (
                            <option key={e} value={e}>{e}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* CONTATO DE EMERGÊNCIA */}
            <div className={styles.secao}>
                <span className={styles.secaoTitulo}>🚨 Contato de Emergência</span>

                <div className={styles.campo}>
                    <label className={styles.label}>Nome</label>
                    <input className={styles.input} type="text" placeholder="Nome completo"
                        value={emergencia.nomeme} onChange={e => handleEmerg("nomeme", e.target.value)} />
                </div>

                <div className={styles.gridDois}>
                    <div className={styles.campo}>
                        <label className={styles.label}>Parentesco</label>
                        <input className={styles.input} type="text" placeholder="Ex: Mãe, Pai..."
                            value={emergencia.parer} onChange={e => handleEmerg("parer", e.target.value)} />
                    </div>
                    <div className={styles.campo}>
                        <label className={styles.label}>Telefone</label>
                        <input className={styles.input} type="tel" placeholder="(00) 00000-0000"
                            value={emergencia.teleme} onChange={e => handleEmerg("teleme", e.target.value)} />
                    </div>
                </div>
            </div>

            {/* FILHOS 
            <div className={styles.secao}>
                <div className={styles.secaoHeader}>
                    <span className={styles.secaoTitulo}>👶 Filhos</span>
                    <button className={styles.btnAdicionar}
                        onClick={() => setFilhos(prev => [...prev, filhoVazio()])}>
                        + Adicionar
                    </button>
                </div>

                {filhos.length === 0 && (
                    <p className={styles.vazio}>Nenhum filho cadastrado.</p>
                )}

                {filhos.map((filho, i) => (
                    <div key={i} className={styles.subCard}>
                        <div className={styles.subCardHeader}>
                            <span className={styles.subCardTitulo}>Filho {i + 1}</span>
                            <button className={styles.btnRemover}
                                onClick={() => setFilhos(prev => prev.filter((_, idx) => idx !== i))}>
                                ✕
                            </button>
                        </div>

                        <div className={styles.campo}>
                            <label className={styles.label}>Nome completo</label>
                            <input className={styles.input} type="text" placeholder="Nome do filho"
                                value={filho.nomfil} onChange={e => handleFilho(i, "nomfil", e.target.value)} />
                        </div>

                        <div className={styles.campo}>
                            <label className={styles.label}>Data de Nascimento</label>
                            <input className={styles.input} type="text" placeholder="dd/mm/aaaa" maxLength={10}
                                value={filho.datani} onChange={e => handleFilho(i, "datani", maskDate(e.target.value))} />
                        </div>
                    </div>
                ))}
            </div>
            */}

            {/* CURSOS */}
            <div className={styles.secao}>
                <div className={styles.secaoHeader}>
                    <span className={styles.secaoTitulo}>🎓 Cursos e Certificados</span>
                    <button className={styles.btnAdicionar}
                        onClick={() => setCursos(prev => [...prev, cursoVazio()])}>
                        + Adicionar
                    </button>
                </div>

                {cursos.length === 0 && (
                    <p className={styles.vazio}>Nenhum curso cadastrado.</p>
                )}

                {cursos.map((curso, i) => (
                    <div key={i} className={styles.subCard}>
                        <div className={styles.subCardHeader}>
                            <span className={styles.subCardTitulo}>Curso {i + 1}</span>
                            <button className={styles.btnRemover}
                                onClick={() => setCursos(prev => prev.filter((_, idx) => idx !== i))}>
                                ✕
                            </button>
                        </div>

                        <div className={styles.campo}>
                            <label className={styles.label}>Nome do Curso</label>
                            <input className={styles.input} type="text" placeholder="Ex: Excel Avançado"
                                value={curso.nomcur} onChange={e => handleCurso(i, "nomcur", e.target.value)} />
                        </div>

                        <div className={styles.gridDois}>
                            <div className={styles.campo}>
                                <label className={styles.label}>Instituição</label>
                                <input className={styles.input} type="text" placeholder="Ex: Senac"
                                    value={curso.nomins} onChange={e => handleCurso(i, "nomins", e.target.value)} />
                            </div>
                            <div className={styles.campo}>
                                <label className={styles.label}>Carga Horária (h)</label>
                                <input className={styles.input} type="number" placeholder="Ex: 40"
                                    value={curso.qtdcar} onChange={e => handleCurso(i, "qtdcar", e.target.value)} />
                            </div>
                        </div>

                        <div className={styles.gridDois}>
                            <div className={styles.campo}>
                                <label className={styles.label}>Data Início</label>
                                <input className={styles.input} type="text" placeholder="dd/mm/aaaa" maxLength={10}
                                    value={curso.datini} onChange={e => handleCurso(i, "datini", maskDate(e.target.value))} />
                            </div>
                            <div className={styles.campo}>
                                <label className={styles.label}>Data Conclusão</label>
                                <input className={styles.input} type="text" placeholder="dd/mm/aaaa" maxLength={10}
                                    value={curso.datfin} onChange={e => handleCurso(i, "datfin", maskDate(e.target.value))} />
                            </div>
                        </div>

                        <div className={styles.campo}>
                            <label className={styles.label}>Certificado (PDF ou imagem)</label>
                            <label className={styles.uploadArea}>
                                <input type="file" accept=".pdf,image/*" style={{ display: "none" }}
                                    onChange={e => handleCursoArquivo(i, e.target.files[0])} />
                                <span className={styles.uploadIcone}>📎</span>
                                <span className={styles.uploadTexto}>
                                    {curso.arquivoNome || "Clique para anexar arquivo"}
                                </span>
                            </label>
                            {curso.arquivoNome && (
                                <span className={styles.arquivoAnexado}>✅ {curso.arquivoNome}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <ApiButton className={styles.btnSalvar} onClick={salvar} disabled={salvando}>
                {salvando ? "Salvando..." : "Salvar Alterações"}
            </ApiButton>

            <BottomNav />
        </div>
    );
}
